export default __webpack_public_path__ + "static/media/gear.6a2f80b8.svg";